export enum  FoodHandlerStatus {
  Pending = 100,
  Active = 200,
  Suspended = 300,
  Blacklisted = 400,
  Barred = 500,
  Expired = 600
}
